import _defineProperty from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { XML_ATTRKEY, XML_CHARKEY } from "./interfaces.js";
import { getOperationArgumentValueFromParameter, getOperationRequestInfo } from "./operationHelpers.js";
import { MapperTypeNames } from "./serializer.js";
import { getPathStringFromParameter } from "./interfaceHelpers.js";
/**
 * The programmatic identifier of the serializationPolicy.
 */

export var serializationPolicyName = "serializationPolicy";
/**
 * This policy handles assembling the request body and headers using
 * an OperationSpec and OperationArguments on the request.
 */

export function serializationPolicy() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var stringifyXML = options.stringifyXML;
  return {
    name: serializationPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var operationInfo, operationSpec, operationArguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                operationInfo = getOperationRequestInfo(request);
                operationSpec = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationSpec;
                operationArguments = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationArguments;

                if (operationSpec && operationArguments) {
                  serializeHeaders(request, operationArguments, operationSpec);
                  serializeRequestBody(request, operationArguments, operationSpec, stringifyXML);
                }

                return _context.abrupt("return", next(request));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}
/**
 * @internal
 */

export function serializeHeaders(request, operationArguments, operationSpec) {
  var _a, _b;

  if (operationSpec.headerParameters) {
    var _iterator = _createForOfIteratorHelper(operationSpec.headerParameters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var headerParameter = _step.value;
        var headerValue = getOperationArgumentValueFromParameter(operationArguments, headerParameter);

        if (headerValue !== null && headerValue !== undefined || headerParameter.mapper.required) {
          headerValue = operationSpec.serializer.serialize(headerParameter.mapper, headerValue, getPathStringFromParameter(headerParameter));
          var headerCollectionPrefix = headerParameter.mapper.headerCollectionPrefix;

          if (headerCollectionPrefix) {
            for (var _i = 0, _Object$keys = Object.keys(headerValue); _i < _Object$keys.length; _i++) {
              var key = _Object$keys[_i];
              request.headers.set(headerCollectionPrefix + key, headerValue[key]);
            }
          } else {
            request.headers.set(headerParameter.mapper.serializedName || getPathStringFromParameter(headerParameter), headerValue);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var customHeaders = (_b = (_a = operationArguments.options) === null || _a === void 0 ? void 0 : _a.requestOptions) === null || _b === void 0 ? void 0 : _b.customHeaders;

  if (customHeaders) {
    for (var _i2 = 0, _Object$keys2 = Object.keys(customHeaders); _i2 < _Object$keys2.length; _i2++) {
      var customHeaderName = _Object$keys2[_i2];
      request.headers.set(customHeaderName, customHeaders[customHeaderName]);
    }
  }
}
/**
 * @internal
 */

export function serializeRequestBody(request, operationArguments, operationSpec) {
  var stringifyXML = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    throw new Error("XML serialization unsupported!");
  };

  var _a, _b, _c, _d, _e;

  var serializerOptions = (_a = operationArguments.options) === null || _a === void 0 ? void 0 : _a.serializerOptions;
  var updatedOptions = {
    xml: {
      rootName: (_b = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.rootName) !== null && _b !== void 0 ? _b : "",
      includeRoot: (_c = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.includeRoot) !== null && _c !== void 0 ? _c : false,
      xmlCharKey: (_d = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.xmlCharKey) !== null && _d !== void 0 ? _d : XML_CHARKEY
    }
  };
  var xmlCharKey = updatedOptions.xml.xmlCharKey;

  if (operationSpec.requestBody && operationSpec.requestBody.mapper) {
    request.body = getOperationArgumentValueFromParameter(operationArguments, operationSpec.requestBody);
    var bodyMapper = operationSpec.requestBody.mapper;
    var required = bodyMapper.required,
        serializedName = bodyMapper.serializedName,
        xmlName = bodyMapper.xmlName,
        xmlElementName = bodyMapper.xmlElementName,
        xmlNamespace = bodyMapper.xmlNamespace,
        xmlNamespacePrefix = bodyMapper.xmlNamespacePrefix,
        nullable = bodyMapper.nullable;
    var typeName = bodyMapper.type.name;

    try {
      if (request.body !== undefined && request.body !== null || nullable && request.body === null || required) {
        var requestBodyParameterPathString = getPathStringFromParameter(operationSpec.requestBody);
        request.body = operationSpec.serializer.serialize(bodyMapper, request.body, requestBodyParameterPathString, updatedOptions);
        var isStream = typeName === MapperTypeNames.Stream;

        if (operationSpec.isXML) {
          var xmlnsKey = xmlNamespacePrefix ? "xmlns:".concat(xmlNamespacePrefix) : "xmlns";
          var value = getXmlValueWithNamespace(xmlNamespace, xmlnsKey, typeName, request.body, updatedOptions);

          if (typeName === MapperTypeNames.Sequence) {
            request.body = stringifyXML(prepareXMLRootList(value, xmlElementName || xmlName || serializedName, xmlnsKey, xmlNamespace), {
              rootName: xmlName || serializedName,
              xmlCharKey: xmlCharKey
            });
          } else if (!isStream) {
            request.body = stringifyXML(value, {
              rootName: xmlName || serializedName,
              xmlCharKey: xmlCharKey
            });
          }
        } else if (typeName === MapperTypeNames.String && (((_e = operationSpec.contentType) === null || _e === void 0 ? void 0 : _e.match("text/plain")) || operationSpec.mediaType === "text")) {
          // the String serializer has validated that request body is a string
          // so just send the string.
          return;
        } else if (!isStream) {
          request.body = JSON.stringify(request.body);
        }
      }
    } catch (error) {
      throw new Error("Error \"".concat(error.message, "\" occurred in serializing the payload - ").concat(JSON.stringify(serializedName, undefined, "  "), "."));
    }
  } else if (operationSpec.formDataParameters && operationSpec.formDataParameters.length > 0) {
    request.formData = {};

    var _iterator2 = _createForOfIteratorHelper(operationSpec.formDataParameters),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var formDataParameter = _step2.value;
        var formDataParameterValue = getOperationArgumentValueFromParameter(operationArguments, formDataParameter);

        if (formDataParameterValue !== undefined && formDataParameterValue !== null) {
          var formDataParameterPropertyName = formDataParameter.mapper.serializedName || getPathStringFromParameter(formDataParameter);
          request.formData[formDataParameterPropertyName] = operationSpec.serializer.serialize(formDataParameter.mapper, formDataParameterValue, getPathStringFromParameter(formDataParameter), updatedOptions);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}
/**
 * Adds an xml namespace to the xml serialized object if needed, otherwise it just returns the value itself
 */

function getXmlValueWithNamespace(xmlNamespace, xmlnsKey, typeName, serializedValue, options) {
  // Composite and Sequence schemas already got their root namespace set during serialization
  // We just need to add xmlns to the other schema types
  if (xmlNamespace && !["Composite", "Sequence", "Dictionary"].includes(typeName)) {
    var result = {};
    result[options.xml.xmlCharKey] = serializedValue;
    result[XML_ATTRKEY] = _defineProperty({}, xmlnsKey, xmlNamespace);
    return result;
  }

  return serializedValue;
}

function prepareXMLRootList(obj, elementName, xmlNamespaceKey, xmlNamespace) {
  if (!Array.isArray(obj)) {
    obj = [obj];
  }

  if (!xmlNamespaceKey || !xmlNamespace) {
    return _defineProperty({}, elementName, obj);
  }

  var result = _defineProperty({}, elementName, obj);

  result[XML_ATTRKEY] = _defineProperty({}, xmlNamespaceKey, xmlNamespace);
  return result;
}